<script setup lang="ts">
import model from '@/ts/model.ts';
import CasinoDiamondIcon from '@/assets/casino-diamond.svg?raw';
import LiveCasinoIcon from '@/assets/live-casino-icon.svg?raw';
import SideNavSportBettingIcon from '../assets/side-nav/side-nav-sport-betting.svg?raw';
import SideNavPromosIcon from '../assets/side-nav/side-nav-promos.svg?raw';
import SideNavFunClubIcon from '@/assets/icons/side-nav-fun-club.svg?raw';
import SideNavWhyFundalorIcon from '../assets/side-nav/side-nav-why-fundalor.svg?raw';
import SideNavFaqIcon from '../assets/side-nav/side-nav-faq.svg?raw';
import SideNavNotificationsIcon from '../assets/side-nav/side-nav-notifications.svg?raw';
import SideNavAccountIcon from '../assets/side-nav/side-nav-account.svg?raw';
import SideNavCashierIcon from '../assets/side-nav/side-nav-cashier.svg?raw';
import ContactUsIcon from '../assets/side-nav/side-nav-contact-us.svg?raw';
import MethodsPageIcon from '../assets/side-nav/side-nav-methods-page.svg?raw';
import { showMobileSideNav } from '@/ts/management/ui-management.ts';
import MobileNavSideItemContactUs from './mobile-nav-side-item-contact-us.vue';
import MobileNavSideItem from './mobile-nav-side-item.vue';
import LangSelector from '../../lang-selector/lang-selector.vue';
import { getLangText } from '@/ts/utils/utils.ts';
import NavBtnStellarStream from '../nav-btn-stellar-stream.vue';
model.on('Navigation', () => showMobileSideNav(false, true));
</script>

<template>
    <div class="mobile-nav-side-overlay" :class="{'displayed': model.mobileSideNavDisplayed}" @click="showMobileSideNav(false)">
        <div class="mobile-nav-side" :class="{'displayed': model.mobileSideNavDisplayed}" @click.prevent.stop>
            <div @click.prevent.stop="showMobileSideNav(false)" class="close">&times;</div>
            <template v-if="model.bonusPointsType == 'stellar-stream' && model.userLoggedIn">
                <div class="nav-items">
                    <nav-btn-stellar-stream :location="'mobile-side-nav'" />
                </div>
                <hr>
            </template>
            <div class="nav-items">
                <mobile-nav-side-item :view="'casino'" :icon="CasinoDiamondIcon" />
                <mobile-nav-side-item :view="'live-casino'" :icon="LiveCasinoIcon" />
                <mobile-nav-side-item :view="'sport-betting'" :icon="SideNavSportBettingIcon" />
                <mobile-nav-side-item :view="'promos'" :icon="SideNavPromosIcon" :label="'Promos'" />
                <mobile-nav-side-item :view="'fun-club'" :icon="SideNavFunClubIcon" />
                <mobile-nav-side-item :view="'why-fundalor'" :icon="SideNavWhyFundalorIcon" />
            </div>
            <hr>
            <div class="nav-items">
                <mobile-nav-side-item :view="'cashier'" :icon="SideNavCashierIcon" :label="'CashierLabel'" :expl-text="`(${getLangText('CashierExplText')})`" location="mobile-nav-side" />
                <mobile-nav-side-item :view="'account'" :icon="SideNavAccountIcon" :label="'AccountLabel'" :expl-text="`(${getLangText('AccountExplText')})`" location="mobile-nav-side" />
                <mobile-nav-side-item :view="'inbox'" :icon="SideNavNotificationsIcon" :label="'InboxLabel'" :expl-text="`(${getLangText('InboxExplText')})`" />
            </div>
            <hr>
            <div class="nav-items">
                <mobile-nav-side-item :view="'methods-page'" :icon="MethodsPageIcon" :label="'MethodsPage'" :lowercase="true" />
                <mobile-nav-side-item :view="'contact-us'" :icon="ContactUsIcon" :label="'ContactUs'" :lowercase="true" />
                <mobile-nav-side-item :view="'faq'" :icon="SideNavFaqIcon" :label="'FAQLabel'" :lowercase="true" />
            </div>
            <hr>
            <div class="nav-items">
                <mobile-nav-side-item-contact-us />
            </div>
            <template v-if="model.supportedLangs.length > 0">
                <hr>
                <div class="nav-items">
                    <lang-selector />
                </div>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/scss/shared";
.mobile-nav-side{
    position: relative;
    $width: 95dvw;
    width: $width;
    height: 100%;
    transition: transform .5s;
    transform: translateX(100%);
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
    padding-top: 50px;
    @include shared.site() using($site-key){
        background: linear-gradient(0deg, shared.theme-color("primary_3", $site-key) 0%, #000000 100%);
    }
    &-overlay{
        display: flex;
        position: fixed;
        top:0;
        left:0;
        background-color: #00000067;
        width:100dvw;
        height: 100vh;
        z-index: 270;
        opacity: 0;
        pointer-events: none;
        transition: opacity .5s;
        align-items: flex-start;
        justify-content: flex-end;
        &.displayed{
            opacity: 1;
            pointer-events: all;
        }
    }
    & > .nav-items{
        position: relative;
        display: flex;
        padding: 0 20px;
        flex-direction: column;
        font-weight: 800 !important;
    }
    & > hr{
        width: calc(100% - 10px);
        border: none;
        border-bottom: 1px dashed;
        margin-bottom: 20px;
        @include shared.site() using($site-key){
            border-color: shared.theme-color("comp3_3", $site-key);
        }
    }
    &.displayed{
        transform: translateX(0%);
    }
    & > .close{
        position: absolute;
        display: flex;
        width: 40px;
        height: 40px;
        margin: 5px;
        text-align: center;
        font-size: 25px;
        line-height: 0;
        justify-content: center;
        align-items: center;
        right:0;
        top:0;
    }
}
</style>